class Logger {
    constructor(enabled = true) {
      this.enabled = enabled;
    }
  
    log(...args) {
      if (this.enabled) {
        console.log(...args);
      }
    }
    
    error(...args) {
      if (this.enabled) {
        console.error(...args);
      }
    }
  
    // Optionally, add a method to toggle logging on and off
    setEnabled(enabled) {
      this.enabled = enabled;
    }
  }
  
  // Example usage:
  const logger = new Logger(true);

  
  logger.setEnabled(false);
  export default logger;

  